import React from 'react';

import { observer } from 'mobx-react';

import { CheckoutForm } from './CheckoutForm/CheckoutForm';
import { StripeElementsProvider } from '../../../../shared/components/stripe';
import { challengeCheckoutStore } from '../../../stores/challengeCheckoutStore';

const PaymentBlock = observer(() => {
  const { challengeCheckoutInfo } = challengeCheckoutStore;

  if (!challengeCheckoutInfo) {
    return null;
  }

  const { paymentIntent } = challengeCheckoutInfo;

  return (
    <StripeElementsProvider
      publishableKey={paymentIntent.publishableKey}
      connectedAccountId={paymentIntent.connectedAccountId}
      elementsOptions={{ clientSecret: paymentIntent.clientSecret }}
    >
      <CheckoutForm />
    </StripeElementsProvider>
  );
});

export { PaymentBlock };
